module.exports = __webpack_public_path__ + "img/oracleSalesCloud.2ddc0fb4.png";